import 'virtual:polyfills';
import './styles/fonts.scss';
import './styles/main.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'wicg-inert';
import { registerSW } from 'virtual:pwa-register';
import { configureEnv } from '@jwp/ott-common/src/env';

import { register } from './modules/register';

import { attachAccessibilityListener } from '#src/utils/accessibility';

// Collect env vars
configureEnv({
  APP_VERSION: import.meta.env.APP_VERSION,

  APP_API_BASE_URL: import.meta.env.APP_API_BASE_URL,
  APP_PLAYER_ID: import.meta.env.APP_PLAYER_ID,

  APP_DEFAULT_CONFIG_SOURCE: import.meta.env.APP_DEFAULT_CONFIG_SOURCE,
  APP_PLAYER_LICENSE_KEY: import.meta.env.APP_PLAYER_LICENSE_KEY,

  APP_CONSENT_COOKIE_NAME: import.meta.env.APP_CONSENT_COOKIE_NAME,
  APP_CONSENT_COOKIE_POLICY_URL: import.meta.env.APP_CONSENT_COOKIE_POLICY_URL,

  APP_FOOTER_TEXT: import.meta.env.APP_FOOTER_TEXT,
  APP_BODY_FONT: import.meta.env.APP_BODY_FONT_FAMILY,
  APP_BODY_ALT_FONT: import.meta.env.APP_BODY_ALT_FONT,
  APP_PUBLIC_URL: import.meta.env.APP_PUBLIC_URL || window.location.origin,

  APP_GTM_TAG_ID: import.meta.env.APP_GTM_TAG_ID,
  APP_GTM_TAG_SERVER: import.meta.env.APP_GTM_TAG_SERVER,
  APP_GTM_LOAD_ON_ACCEPT: import.meta.env.APP_GTM_LOAD_ON_ACCEPT,
  APP_GTM_SCRIPT: import.meta.env.APP_GTM_SCRIPT,

  APP_CHROMECAST_APPLICATION_ID: import.meta.env.APP_CHROMECAST_APPLICATION_ID,
});

attachAccessibilityListener();

async function run() {
  await register();

  attachAccessibilityListener();

  const { default: App } = await import('./App');
  const rootElement = document.getElementById('root');

  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App />);
    /*Sobreescribe el nombre de UmbraStream en la pestaña de google
    const setTitle = () =>
      document.title = "Umbra.s";

    setInterval(setTitle, 500);*/

    const applyMeta = () => {
      // Title
      if (document.title !== "Umbra") {
        document.title = "Umbra";
      }

      // Description
      const metaDesc = document.querySelector("meta[name='description']");
      if (metaDesc && metaDesc.getAttribute("content") !== "Streaming de cine de horror en Umbra Stream") {
        metaDesc.setAttribute(
          "content",
          "Streaming de cine de horror en Umbra Stream"
        );
      }
    };

    // Ejecutar una vez al inicio
    applyMeta();

    // Observar cambios en el DOM (Helmet de JWP)
    const observer = new MutationObserver(() => {
      applyMeta();
    });

    // Observa cambios en <head>
    observer.observe(document.head, {
      childList: true,
      subtree: true,
    });

    setInterval(applyMeta, 500);
      
    } else {
      console.info('Application - rootElement not found');
    }
  }

run();

const refresh = registerSW({
  immediate: true,
  onNeedRefresh: () => refresh(true),
});
